import {IFields} from './applicationFeature';

export class AffirmationClass {
    fields: IFields[];
    constructor() {
        this.fields = [];
        this.fields = [
            { label: 'Όνομα παιδιού', field: 'child_first_name', type: 'text', value: '', searchType: '' },
            { label: 'Επώνυμο παιδιού', field: 'child_last_name', type: 'text', value: '', searchType: '' },
            { label: 'Όνομα πατέρα', field: 'father_first_name', type: 'text', value: '', searchType: '' },
            { label: 'Επώνυμο πατέρα', field: 'father_last_name', type: 'text', value: '', searchType: '' },
            { label: 'Όνομα μητέρας', field: 'mother_first_name', type: 'text', value: '', searchType: '' },
            { label: 'Επώνυμο μητέρας', field: 'mother_last_name', type: 'text', value: '', searchType: '' },
            { label: 'Επίπεδο δραστηριότητας', field: 'level_description', type: 'text', value: '', searchType: '' },
            { label: 'Ημερομηνία Εγγραφής', field: 'enroll_date', type: 'date', value: '', searchType: '' },
        ];
    }

    getSearchFields() {
        return this.fields;
    }
}
